import { createAction, props } from '@ngrx/store';
import { Resource } from '@ngxp/rest';
import { BinaryFileResource, FileType, PotentialPlaceholder } from './binary.model';

const PREFIX = '[Binary] ';

export const changeFileAction = createAction(
	PREFIX + 'Change File',
	props<{
		resource: Resource;
		linkRel: string;
		fileType: FileType;
		file: File;
	}>()
);

export const changeFileSuccessAction = createAction(
	PREFIX + 'Change File Success',
	props<{
		fileType: FileType;
		file: File;
		report?: PotentialPlaceholder[];
	}>()
);

export const downloadFileAction = createAction(
	PREFIX + 'Download File',
	props<{
		binaryFile: BinaryFileResource;
	}>()
);
